import AxiosInstance from "../instance";
import {emptyFn} from "../utils";

const searchWeatherInfo = async (query: string) => {
    const response = await AxiosInstance.getInstance().get("/groupapi/weather", {
        params: {
            "function": "search",
            "query": query
        }
    }).catch(emptyFn);
    return response;
};

const getRealtimeWeatherInfo = async (city: string) => {
    const response = await AxiosInstance.getInstance().get("/groupapi/weather", {
        params: {
            "function": "realtime",
            city
        }
    });
    return response;
};

const getHistoryWeatherInfo = async (city: string, dateFrom: string, dateTo: string) => {
    const response = await AxiosInstance.getInstance().get("/groupapi/weather", {
        params: {
            "function": "history",
            "city": city,
            "dt": dateFrom,
            "end_dt": dateTo
        }
    });
    return response;
};

const getWeatherForecastInfo = async (city: string) => {
    const response = await AxiosInstance.getInstance().get("/groupapi/weather", {
        params: {
            "function": "forecast",
            city,
            days: 10
        }
    });
    return response;
};

export {
    getWeatherForecastInfo,
    getHistoryWeatherInfo,
    getRealtimeWeatherInfo,
    searchWeatherInfo
}


// WEBPACK FOOTER //
// ./src/api/models/WeatherAPI.ts